export const GET_DELIVERY_CHARGES_SLABS_REQUEST =
  "get_delivery_charges_slabs_request";
export const GET_DELIVERY_CHARGES_SLABS_RESPONSE =
  "get_delivery_charges_slabs_response";

export const UPDATE_DELIVERY_CHARGES_SLABS_REQUEST =
  "update_delivery_charges_slabs_request";
export const UPDATE_DELIVERY_CHARGES_SLABS_RESPONSE =
  "update_delivery_charges_slabs_response";
